import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, memo } from 'react';
import Collapse from '@mui/material/Collapse';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import ExpandLess from '@pixel/assets/icons/ExpandLess';
import ExpandMore from '@pixel/assets/icons/ExpandMore';
import { useTheme, styled } from '../styles';
import ListSelectionInput from '../ListSelectionInput';
import { CHECKBOX_CELL_WIDTH, COLLAPSE_CELL_WIDTH, generateStickyLeft, stickyLeft, stickyRight, stickyShadowRight, stickyShadowLeft, generateStickyRight } from './DataTableConstants';

//create a type for onClick

const CellContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'minWidth' && prop !== 'maxWidth'
})(_ref => {
  let {
    minWidth,
    maxWidth
  } = _ref;
  return {
    display: 'block',
    width: 'auto',
    minWidth,
    maxWidth
  };
});
function CustomRow(_ref2) {
  let {
    id,
    columns,
    isSelected,
    isPartiallySelected,
    highlightable = false,
    isHighlighted = false,
    labelCheckboxKey,
    labelExpandKey,
    nodeData,
    selectable,
    stickyLeftWidths,
    onSelection,
    onClick,
    selectionType,
    renderActions,
    renderExpand,
    renderExpandButton,
    stickyAction,
    labelCheckboxAriaLabel,
    labelCollapseAriaLabel,
    labelExpandAriaLabel,
    verticalAlign = 'middle',
    rowOverflow = true,
    nodeContext = {},
    expandButtonPosition
  } = _ref2;
  const theme = useTheme();
  const [showCollapse, setShowCollapse] = useState(false);
  const handleCollapseClick = () => {
    setShowCollapse(active => !active);
  };

  // TODO: optimize, also filter out rows that dont need to be cells
  const cellsToRender = columns.filter(() => true).map(column => column);
  const shouldRenderActions = renderActions && typeof renderActions === 'function';
  const shouldRenderExpand = renderExpand && typeof renderExpand === 'function';
  const borderBottom = shouldRenderExpand ? 'unset' : '1px solid #E4EDF3';
  let totalColumns = cellsToRender.length;
  if (shouldRenderActions) {
    totalColumns += 1;
  }
  if (shouldRenderExpand) {
    totalColumns += 1;
  }
  if (selectable) {
    totalColumns += 1;
  }
  const actionsCellSx = {
    borderBottom,
    padding: theme.spacing(0.5, 1),
    "& > div": {
      justifyContent: "flex-end"
    },
    ...(stickyAction ? {
      ...stickyRight,
      boxShadow: stickyShadowRight
    } : {})
  };
  const rowOverflowTrueSx = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
  const rowOverflowSx = {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    hyphens: 'auto'
  };

  // const cells = useMemo(() => cellsToRender.map(cell => cell.renderCell && typeof cell.renderCell === 'function' && cell.renderCell(nodeData)), [nodeData])

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableRow, {
    id: id
    // data-qa={`CustomRow-${id}`}
    ,
    sx: {
      verticalAlign,
      borderLeft: "3px solid #ff9900",
      color: highlightable && isHighlighted ? theme.palette.highlight.text : "inherit",
      backgroundColor: highlightable && isHighlighted ? theme.palette.highlight.background : theme.palette.background.paper,
      '&:hover': {
        backgroundColor: highlightable ? theme.palette.highlight.background_hover : "inherit",
        "& > td": {
          backgroundColor: highlightable ? theme.palette.highlight.background_hover : theme.palette.background.paper
        }
      }
    },
    onClick: e => onClick && onClick(e, nodeData)
  }, selectable && /*#__PURE__*/React.createElement(TableCell, {
    variant: "body",
    align: "left",
    width: CHECKBOX_CELL_WIDTH,
    size: "small",
    sx: {
      minWidth: CHECKBOX_CELL_WIDTH,
      width: CHECKBOX_CELL_WIDTH,
      padding: theme.spacing(0.5, 1),
      ...stickyLeft,
      boxShadow: stickyShadowLeft,
      borderBottom
    }
  }, /*#__PURE__*/React.createElement(ListSelectionInput, {
    selectionType: selectionType,
    selected: isSelected,
    isPartiallySelected: isPartiallySelected,
    ariaLabel: labelCheckboxAriaLabel.replace('{label}', nodeData[labelCheckboxKey]),
    onSelection: () => onSelection && onSelection(nodeData, !isSelected)
  })), shouldRenderExpand && expandButtonPosition === 'left' && /*#__PURE__*/React.createElement(TableCell, {
    variant: "body",
    align: "left",
    size: "small",
    width: COLLAPSE_CELL_WIDTH,
    sx: {
      padding: theme.spacing(1, 1.5),
      borderBottom,
      ...generateStickyLeft(selectable ? CHECKBOX_CELL_WIDTH : 0),
      backgroundColor: highlightable && isHighlighted ? theme.palette.highlight.background : theme.palette.background.paper,
      boxShadow: stickyShadowLeft
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleCollapseClick,
    title: showCollapse ? labelCollapseAriaLabel.replace('{label}', nodeData[labelExpandKey]) : labelExpandAriaLabel.replace('{label}', nodeData[labelExpandKey])
  }, showCollapse ? /*#__PURE__*/React.createElement(ExpandLess, null) : /*#__PURE__*/React.createElement(ExpandMore, null))), cellsToRender.map((column, index) => /*#__PURE__*/React.createElement(TableCell, {
    key: column.id,
    variant: "body",
    align: "left",
    size: "small",
    sx: {
      padding: theme.spacing(1, 1.5),
      borderBottom,
      minWidth: column.sticky ? column.stickyWidth : column.minWidth,
      maxWidth: column.sticky ? column.stickyWidth : column.maxWidth,
      width: column.sticky ? column.stickyWidth : undefined,
      ...(column.sticky ? {
        ...generateStickyLeft(stickyLeftWidths[index]),
        backgroundColor: highlightable && isHighlighted ? theme.palette.highlight.background : theme.palette.background.paper,
        boxShadow: stickyShadowLeft
      } : {})
    }
  }, /*#__PURE__*/React.createElement(CellContainer, {
    sx: rowOverflow ? rowOverflowTrueSx : rowOverflowSx
  }, column.renderCell(nodeData, nodeContext)))), shouldRenderExpand && expandButtonPosition === 'right' && /*#__PURE__*/React.createElement(TableCell, {
    variant: "body",
    align: "right",
    size: "small",
    width: COLLAPSE_CELL_WIDTH,
    sx: {
      borderBottom,
      ...generateStickyRight(selectable ? CHECKBOX_CELL_WIDTH : 0),
      backgroundColor: highlightable && isHighlighted ? theme.palette.highlight.background : theme.palette.background.paper,
      boxShadow: stickyShadowLeft
    }
  }, renderExpandButton ? renderExpandButton({
    node: nodeData,
    isExpanded: showCollapse,
    handleCollapseClick
  }) : /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleCollapseClick
  }, showCollapse ? /*#__PURE__*/React.createElement(ExpandLess, null) : /*#__PURE__*/React.createElement(ExpandMore, null))), shouldRenderActions && /*#__PURE__*/React.createElement(TableCell, {
    variant: "body",
    align: "right",
    size: "small",
    sx: {
      width: 64,
      ...actionsCellSx,
      backgroundColor: highlightable && isHighlighted ? theme.palette.highlight.background : theme.palette.background.paper
    }
  }, renderActions(nodeData))), shouldRenderExpand && /*#__PURE__*/React.createElement(TableRow, {
    sx: {
      '& > *': {
        borderBottom
      }
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: totalColumns,
    style: expandButtonPosition === 'left' ? {
      paddingBottom: 0,
      paddingTop: 0
    } : {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Collapse, {
    in: showCollapse,
    timeout: "auto",
    unmountOnExit: true
  }, renderExpand(nodeData)))));
}
const MemoizedCustomRow = /*#__PURE__*/memo(CustomRow);
export default MemoizedCustomRow;